import { CreateSupportTicketRequestSchema, CreateSupportTicketResponseSchema } from './create-support-ticket.schema';
/**
 * Create Support Ticket Endpoint Contract
 * Authenticated – creates a Zammad ticket with user/tenant context from JWT
 */ export const createSupportTicketContract = {
    method: 'POST',
    path: '/api/v2/support/ticket',
    description: 'Create a support ticket in Zammad (authenticated, auto-fills user/tenant data)',
    requestSchema: CreateSupportTicketRequestSchema,
    responseSchema: CreateSupportTicketResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin sessions cannot create tenant support tickets',
            404: 'Not Found - authenticated user record missing',
            503: 'Service Unavailable - Zammad not configured or unreachable'
        }
    }
};

//# sourceMappingURL=create-support-ticket.contract.js.map